import { render, staticRenderFns } from "./PhysicalPackages.vue?vue&type=template&id=e80128ac&scoped=true"
import script from "./PhysicalPackages.vue?vue&type=script&lang=js"
export * from "./PhysicalPackages.vue?vue&type=script&lang=js"
import style0 from "./PhysicalPackages.vue?vue&type=style&index=0&id=e80128ac&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80128ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e80128ac')) {
      api.createRecord('e80128ac', component.options)
    } else {
      api.reload('e80128ac', component.options)
    }
    module.hot.accept("./PhysicalPackages.vue?vue&type=template&id=e80128ac&scoped=true", function () {
      api.rerender('e80128ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/physicalPackages/PhysicalPackages.vue"
export default component.exports